// extracted by mini-css-extract-plugin
module.exports = {"header-link":"header-link_header-link__svBPT","header-link-active":"header-link_header-link-active__q8Ki1"};